import React from "react";
import "../../assets/css/user/topCategories/TopCategories.css";


const categories = [
  {
    id: 1,
    label: "Health & Wellness",
    deals: 45,
    iconBg: "#EEF0FB",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          stroke="#E05A7A"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 2,
    label: "Beauty & Spa",
    deals: 38,
    iconBg: "#EEEDFB",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l1.8 3.6L18 6.5l-3 2.9.7 4.1L12 11.4l-3.7 2.1.7-4.1-3-2.9 4.2-.9L12 2z" stroke="#7C6FCD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 17l-1 4M19 17l1 4M9 19h6" stroke="#7C6FCD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 3,
    label: "Auto & Home",
    deals: 27,
    iconBg: "#E8F3FB",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" stroke="#3B82C4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 21V12h6v9" stroke="#3B82C4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 4,
    label: "Family & Kids",
    deals: 32,
    iconBg: "#E8FAF3",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="6" r="2.5" stroke="#29A677" strokeWidth="1.8" />
        <circle cx="17" cy="5" r="2" stroke="#29A677" strokeWidth="1.8" />
        <path d="M4 20v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3" stroke="#29A677" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M19 13c1.5 0 3 1 3 3v3" stroke="#29A677" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 5,
    label: "Food & Drink",
    deals: 51,
    iconBg: "#FEF3E8",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3l18 18M10.5 10.5A4 4 0 0 0 6 6M6 6v12M18 8c0 3.3-2.7 6-6 6" stroke="#E07B30" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 14v6" stroke="#E07B30" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 6,
    label: "Travel",
    deals: 19,
    iconBg: "#FEF9E3",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.5l-9.5-9.5-2 4.5-5-1.5 2.5 2.5-3.5 3.5 4 1 1 4 3.5-3.5 2.5 2.5-1.5-5 4.5-2z" stroke="#D4A017" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 7,
    label: "Education",
    deals: 23,
    iconBg: "#EEF0FB",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 10l-10-7L2 10l10 7 10-7z" stroke="#5B6FCD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5" stroke="#5B6FCD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 8,
    label: "Fitness",
    deals: 29,
    iconBg: "#FDE8E8",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 6.5l11 11M17.5 6.5l-11 11" stroke="#E05A5A" strokeWidth="1.8" strokeLinecap="round" />
        <rect x="2" y="9" width="4" height="6" rx="1.5" stroke="#E05A5A" strokeWidth="1.8" />
        <rect x="18" y="9" width="4" height="6" rx="1.5" stroke="#E05A5A" strokeWidth="1.8" />
        <path d="M6 12H2M22 12h-4" stroke="#E05A5A" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
];

export default function TopCategories() {
  return (
    <section className="tc-section">
      <div className="tc-header">
        <h2 className="tc-title">Top Categories</h2>
        <p className="tc-subtitle">Browse deals by category</p>
      </div>

      <div className="tc-grid">
        {categories.map((cat) => (
          <div className="tc-card" key={cat.id}>
            <div className="tc-icon-wrap" style={{ backgroundColor: cat.iconBg }}>
              {cat.icon}
            </div>
            <h3 className="tc-label">{cat.label}</h3>
            <p className="tc-deals">{cat.deals} deals</p>
          </div>
        ))}
      </div>
    </section>
  );
}